<template>
	<div>
		<v-dialog v-model="field_dialog" no-click-animation persistent scrollable content-class="full-height field-form" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow>Field</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>
		            <v-layout wrap>

		            	<v-form data-vv-scope="fields" full-width padding-all-16>

		            		<v-flex xs12 sm12 md12 
					        	@click="fn_openFieldList(false)">

				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.fieldData.name" 
					               	label="Select Field" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="ref_fieldName">
				               </v-text-field>
				            </v-flex>

		            		<v-flex xs12 sm12 md12>
					           	<v-text-field 
					           		v-model="$parent.Form.fieldData.displayName" 
					           		label="Display Name" 
					           		placeholder=" "
					           		v-validate="'required'" 
				               		data-vv-name="displayName" 
				               		data-vv-as="display name"
				               		:error-messages="errors.collect('fields.displayName')"
				               		required>
					           	</v-text-field>
					        </v-flex>

				            <!-- <v-flex xs12 sm12 md12 
					        	@click="fn_openSectionList">

				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.fieldData.sectionName" 
					               	label="Section" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="ref_fieldSection"
					               	v-validate="'required'" 
				               		data-vv-name="section" 
				               		:error-messages="errors.collect('fields.section')"
				               		required>
				               </v-text-field>
				            </v-flex> -->

							<v-flex xs12 sm12 md12>

				               <v-text-field  
					               	:disabled="true"
					               	v-model="$parent.Form.fieldData.sectionName" 
					               	label="Section" 
					               	placeholder=" " 
					               	ref="ref_fieldSection"
				               		required>
				               </v-text-field>
				            </v-flex>

				            <!-- Required -->
					        <v-flex xs12 sm12 md12>
					           	<v-checkbox right-align-checkbox label="Required" v-model="$parent.Form.fieldData.isRequired"></v-checkbox>
					        </v-flex>
			            </v-form>

		            </v-layout>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="fn_closeFieldSectionDialog">close</v-btn>
		          	<v-btn small color="blue darken-1" flat @click="fn_checkValidations">Done</v-btn>
		        </v-card-actions>
		    </v-card>

		    

	    </v-dialog>
	</div>
</template>

<script>
const diajs =  require('../masters/forms/dialog').dialogjs;
const sectionListId = require('../../config.js').configs.mastersPredefinedLists.sectionListGUID;

export default{
	props:['isAccountGroup'],
	data(){
		return{
			field_dialog:false,
			invalidFields: false,
			viaFieldForm:null
		}
	},
	methods:{
		openDialogWeb: function () {
			this.$validator.reset();
			this.field_dialog = true;
		},
		closeDialogWeb: function () {
			this.field_dialog = false;
		},

		fn_getFieldData: function () {
			return this.$parent.Form.fieldData;	
		},

		fn_openFieldList: function (resetFields, section, sectionIndex) {
			if(sectionIndex != undefined && this.$parent.Form.fieldItems && this.$parent.Form.fieldItems.length && this.$parent.Form.fieldItems[sectionIndex].fields && this.$parent.Form.fieldItems[sectionIndex].fields.length && this.$parent.Form.fieldItems[sectionIndex].fields.length >= 5){
				this.showToast('Max limit of 5 fields reached');
				return;
			}

			resetFields ? this.$parent.fn_resetFieldData() : '';

			if(section){
				this.$parent.Form.fieldData.sectionId = section.sectionId;
				this.$parent.Form.fieldData.sectionName = section.sectionName;
			}

			this.$parent.fn_openDialogWeb('web', 'FieldList', 'ref_fieldList');
		},

		fn_setFieldValue: function (value) {
			console.log(value);
			let selectedField = JSON.parse(JSON.stringify(value));

			if(this.$parent.Form.fieldData.sectionId && this.$parent.Form.fieldData.sectionName){
				selectedField.sectionId = this.$parent.Form.fieldData.sectionId;
				selectedField.sectionName = this.$parent.Form.fieldData.sectionName;
			}

			this.$parent.Form.fieldData.fieldId = selectedField.fieldId;
			this.$parent.Form.fieldData.name = selectedField.name;
			this.$parent.Form.fieldData.displayName = selectedField.name;
			// this.$parent.Form.fieldData.fieldType = JSON.parse(selectedField.fieldType);
			this.$parent.Form.fieldData.fieldType = selectedField.fieldType;
			this.$parent.Form.fieldData.isRequired = selectedField.isRequired;

			// this.$parent.Form.fieldData = JSON.parse(JSON.stringify(selectedField));
			// this.$parent.Form.fieldData.fieldType = JSON.parse(selectedField.fieldType);
			// this.$parent.Form.fieldData.displayName = this.$parent.Form.fieldData.name;
			
			this.$parent.fn_closeDialog();

			if(!this.field_dialog){
				this.$parent.fn_openDialogWeb('web', 'FieldType', 'ref_fieldsForm');
			}
		},

		// fn_updateSectionList: function (sectionItem) {
		// 	if(!this.$parent.sectionItemList.length){
		// 		this.$parent.sectionItemList.splice(0, 0, sectionItem);
		// 	}
		// 	else{
		// 		for(let i=0;i<this.$parent.sectionItemList.length;i++){
		// 			this.$parent.sectionItemList[i] = sectionItem;
		// 			this.$forceUpdate();
		// 		}
		// 	}
		// 	this.$parent.fn_closeDialog();

		// 	this.fn_addSection(sectionItem);
		// },

		fn_updateSection: function (section) {
			this.$parent.Form.fieldData.sectionId = section.sectionId;
			this.$parent.Form.fieldData.sectionName = section.sectionName;
			this.$forceUpdate();
			this.errors.remove('fields.section');
			this.$parent.fn_closeDialog();
		},

		fn_addSection: function (section) {
			console.log(section);

			// if(updateSection){
			// 	this.$parent.Form.fieldData.sectionId = section.sectionId;
			// 	this.$parent.Form.fieldData.sectionName = section.sectionName;
			// 	this.$forceUpdate();
			// 	this.errors.remove('fields.section');
			// 	this.$parent.fn_closeDialog();
			// }
			// else{
				let itemIndex =	this.$parent.Form.fieldItems.findIndex(item => 
					item.section.sectionName.toLowerCase() == section.sectionName.toLowerCase() && item.section.sectionId != section.sectionId);
				if(itemIndex!=-1){
					// this.$parent.snackbar = true;
					// this.$parent.snackbar_msg = "This section already exist.";
					this.showToast("This section already exists");
					return;
				}

				let sectionObj = {};
				sectionObj.section = {};

				sectionObj.section.sectionId = section.sectionId;
				sectionObj.section.sectionName = section.sectionName;
				sectionObj.section.isHidden = false;

				// sectionObj.section.elementId = "id_"+this.randomFourCharString();

				let editSection = false;

				for(let i=0; i<this.$parent.Form.fieldItems.length; i++){
					if(this.$parent.Form.fieldItems[i].section.sectionId == section.sectionId){
						this.$parent.Form.fieldItems[i].section = sectionObj.section;
						editSection = true;
						break;
					}
				}

				sectionObj.fields = [];

				if(!editSection){
					this.$parent.Form.fieldItems.push(sectionObj);
				}

				//In case of creating new section from section list
				if(this.$parent.$refs['ref_sectionList'].sectionListDialog){
					this.$parent.$refs['ref_sectionList'].selectedSection = section.sectionName;
					this.fn_updateSection(section);
				}
				
				this.fn_scrollToItem(sectionObj.section.sectionId);
				console.log(this.$parent.sectionItemList);
				this.$parent.fn_closeDialog();
			//}
		},

		fn_openSectionForm: function () {
			this.$parent.fn_openDialogWeb('web', 'AddSection', 'ref_sectionForm');
		},

		fn_openSectionList: function () {
			// !viaFieldForm ? this.$parent.fn_resetFieldData() : '';
			// this.viaFieldForm = viaFieldForm;
			this.$parent.fn_openDialogWeb('web', 'SectionList', 'ref_sectionList');
		},

		fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
      		let self = this;
		
			var checkRefs = setInterval(function(){
	          if(self.$refs.hasOwnProperty(ref)){

	          	self.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);

	            clearInterval(checkRefs);
	          }
	        },50);
		},

		fn_editSection: function (section) {
			this.fn_openSectionForm();
			this.$eventHub.$emit('editSection', section);
		},

		fn_checkValidations: function () {
			let self = this;
			this.$validator.validateAll('fields').then((result) => {
		        if(result){
		        	self.fn_saveField();
		        }
		    });
		},

		fn_openFieldFormDialog: function () {
			this.$parent.fn_openDialogWeb('web', 'Field', 'ref_fieldsForm');
		},

		fn_saveField: function () {

			if(this.isAccountGroup && this.$parent.Form.fieldData.accountGroupFieldId){
				this.$parent.Form.fieldData.transactionTypeFieldId = this.$parent.Form.fieldData.accountGroupFieldId;
			}

			!this.$parent.Form.fieldData.transactionTypeFieldId ? this.$parent.Form.fieldData.transactionTypeFieldId = this.guid() : '';

			let fieldItemIndex = null;
			for(let i=0;i<this.$parent.Form.fieldItems.length;i++){
				let fields = this.$parent.Form.fieldItems[i].fields;
				let sectionName = this.$parent.Form.fieldItems[i].section.sectionName;
				// let fieldName = null;

				for(let i=0; i<fields.length; i++){
					if(fields[i].transactionTypeFieldId != this.$parent.Form.fieldData.transactionTypeFieldId){

						// if(fields[i].displayName.toLowerCase() == this.$parent.Form.fieldData.displayName.toLowerCase()){
						// 	fieldName = this.$parent.Form.fieldData.displayName;
						// 	fieldItemIndex = i;
						// 	break;
						// }

						if(fields[i].fieldId == this.$parent.Form.fieldData.fieldId){
							fieldItemIndex = i;
							break;
						}
					}
				}



				if(fieldItemIndex!=null){
					// this.$parent.snackbar = true;
					// this.$parent.snackbar_msg = 'This field already exist under "<b>'+sectionName+'</b>" section';
					this.showToast('This field already exists under "'+sectionName+'" section');
					this.$parent.Form.fieldData.transactionTypeFieldId = null;
					break;
				}
			}

			if(fieldItemIndex!=-1 && fieldItemIndex!=null){
				return;
			}

			let sectionObj = {};
			sectionObj.section = {};

			sectionObj.section.sectionId = this.$parent.Form.fieldData.sectionId;
			sectionObj.section.sectionName = this.$parent.Form.fieldData.sectionName;

			sectionObj.section.isHidden = false;
			// sectionObj.section.elementId = "id_"+this.$parent.randomFourCharString();

			sectionObj.fields = [];
			let fieldObj = {};
			fieldObj = JSON.parse(JSON.stringify(this.$parent.Form.fieldData));

			// fieldObj.elementId = "id_"+this.$parent.randomFourCharString();
			fieldObj.isHidden = false;


			let sectionIndex = this.$parent.Form.fieldItems.findIndex(item => item.section.sectionId == this.$parent.Form.fieldData.sectionId);

			let fieldIndex = null;

			if(sectionIndex!=-1){
				fieldIndex = this.$parent.Form.fieldItems[sectionIndex].fields.findIndex(item => item.transactionTypeFieldId == this.$parent.Form.fieldData.transactionTypeFieldId);

				if(fieldIndex!=-1){
					this.$parent.Form.fieldItems[sectionIndex].fields[fieldIndex] = fieldObj;
					this.$parent.$forceUpdate();
				}
				else{
					//Remove from old
					if(this.$parent.Form.activeSectionIndex!=null && this.$parent.Form.activeFieldIndex!=null){
						this.fn_removeField(this.$parent.Form.activeSectionIndex, this.$parent.Form.activeFieldIndex)
					}
					//Pushed in to new
					this.$parent.Form.fieldItems[sectionIndex].fields.push(fieldObj);
					this.fn_scrollToItem(fieldObj.transactionTypeFieldId);
				}
			}
			else{
				//Remove from old
				if(this.$parent.Form.activeSectionIndex!=null && this.$parent.Form.activeFieldIndex!=null){
					this.fn_removeField(this.$parent.Form.activeSectionIndex, this.$parent.Form.activeFieldIndex);
				}
				//Pushed in to new
				sectionObj.fields.push(fieldObj);
				this.$parent.Form.fieldItems.push(sectionObj);
				this.fn_scrollToItem(fieldObj.transactionTypeFieldId);
			}

			if(this.isAccountGroup){
				fieldObj.accountGroupFieldId = fieldObj.transactionTypeFieldId;
			}

			this.$parent.fieldItemsComponentKey = this.guidWeb();

			this.fn_closeFieldSectionDialog();	
		},

		fn_scrollToItem: function (elementId) {
			let self = this;
			setTimeout(function () {
				self.$vuetify.goTo('#item_'+elementId, self.scrollOptions);	
			},100);
		},

		fn_removeField: function (sIndex, fIndex) {
			let fieldsArray = this.$parent.Form.fieldItems[sIndex].fields;

			// if(this.$parent.Form.transactionTypeFormId){
			// 	let obj = {};
			// 	obj.fieldId = fieldsArray[fIndex].transactionTypeFieldId;
			// 	this.$parent.Form.deletedFieldIds.push(obj);
			// }
			
			fieldsArray.splice(fIndex, 1);
		},

		fn_editField: function (fieldItem, sIndex, fIndex) {
			this.$parent.Form.activeSectionIndex = sIndex;
			this.$parent.Form.activeFieldIndex = fIndex;
			this.$parent.Form.fieldData = JSON.parse(JSON.stringify(fieldItem));
			this.fn_openFieldFormDialog();
		},

		fn_openMoveFieldDialog: function (sIndex, fIndex) {
			this.$parent.Form.activeSectionIndex = sIndex;
			this.$parent.Form.activeFieldIndex = fIndex;
			this.$parent.fn_openDialogWeb('web', 'Field', 'ref_moveField');
		},

		fn_moveField: function (sIndex, fIndex) {
			let fieldToMove = this.$parent.Form.fieldItems[this.$parent.Form.activeSectionIndex].fields[this.$parent.Form.activeFieldIndex];
			fieldToMove.sectionId = this.$parent.Form.fieldItems[sIndex].fields[fIndex].sectionId;
			fieldToMove.sectionName = this.$parent.Form.fieldItems[sIndex].fields[fIndex].sectionName;

			this.$parent.Form.fieldItems[this.$parent.Form.activeSectionIndex].fields.splice(this.$parent.Form.activeFieldIndex, 1);

			let fieldIndex = fIndex;

			if(this.$parent.Form.activeFieldIndex >= fIndex || this.$parent.Form.activeSectionIndex != sIndex){
				fieldIndex = fieldIndex+1;
			}

			this.$parent.Form.fieldItems[sIndex].fields.splice(fieldIndex, 0, fieldToMove);
			
			this.fn_closeMoveFieldDialog();
		},

		fn_openReorderSectionDialog: function () {
			this.$parent.fn_openDialogWeb('web', 'Field', 'ref_reorderSection');
		},

		fn_applyReorder: function (fieldItems) {
			this.$parent.Form.fieldItems = JSON.parse(JSON.stringify(fieldItems));
			this.$parent.fn_closeDialog();
		},

		fn_closeFieldSectionDialog: function () {
			this.$parent.Form.activeSectionIndex = null;
			this.$parent.Form.activeFieldIndex = null; 
			this.$parent.fn_closeDialog();
		},

		fn_closeMoveFieldDialog: function () {
			this.$parent.Form.activeSectionIndex = null;
			this.$parent.Form.activeFieldIndex = null;
			this.$parent.fn_closeDialog();
		},

		fn_menuItemClick: function(tagId, menuId, menuAction){
			// tagId id form future use
			// menuId id form future use
			this.$parent.backButtonPress = false;

			if(menuAction=='newSectionListItem'){
				this.$router.push({path:'/masters/lists/'+sectionListId+'/items/new', query:{tagId:this.guidWeb(), listTitle:"Section"}})
			}
			else if(menuAction=='newList'){
				this.$router.push({path:'/masters/lists/new', query:{tagId:this.guidWeb()}})
			}
			else if(menuAction=='newAccountGroup'){
				this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb()}})
			}
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/fields/dialog_field_form.vue